import Constants from '@/Constants';
import { AvailableTranslation } from '@/models/AvailableTranslation';
import Item from '@/models/Item';
import { LanguageType } from '@/models/LanguageType';
import { LessonStartAndFinishData } from '@/models/LessonStartAndFinishData';
import { LinkMetadata } from '@/models/LinkMetadata';
import { contentService } from '@/services/ContentService';
import { ApplicationState } from '@/store';
import { startLessonRequest } from '@/store/lesson/action';
import React, { useCallback, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ScormPlayer from './scormPlayer';
import './style.scss';

interface Props {
    content: Item;
    onFinish: () => void;
}

const ScormLink: React.FC<Props> = (props: Props) => {
    const lessonId: number = Number(useParams<{ lessonId: string }>().lessonId);
    const courseId: number = Number(useParams<{ courseId: string }>().courseId);
    const classEnrollmentId: number = Number(useParams<{ enrollmentId: string }>().enrollmentId);

    const { content, onFinish } = props;

    const [playScorm, setPlayScorm] = useState<boolean>(false);

    const dispatch = useDispatch();

    const { strings, currentContentLanguage, personId } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        currentContentLanguage: state.locale.currentContentLanguage || (state.locale.data._LANGUAGE as LanguageType),
        personId: state.identity.data.person.id,
    }));

    const [currentContentTranslation, setCurrentContentTranslation] = useState<AvailableTranslation>();

    const getDescription = (linkMetadata: LinkMetadata, contentTranslation: AvailableTranslation): string => {
        if (linkMetadata && linkMetadata.description) {
            return linkMetadata.description;
        } else if (contentTranslation && contentTranslation.description) {
            return contentTranslation.description;
        } else {
            return '';
        }
    };

    const loadNewPathByNewLanguage = useCallback(() => {
        if (content && currentContentLanguage) {
            setCurrentContentTranslation(contentService.getContentTranslationByLanguageType(content, currentContentLanguage));
        }
    }, [currentContentLanguage]);

    useEffect(loadNewPathByNewLanguage, [currentContentLanguage]);

    const [cookies] = useCookies([Constants.scormCdnTest.COOKIE_NAME]);

    const startScormView = (event: React.MouseEvent) => {
        event.preventDefault();
        setPlayScorm(true);
        dispatch(
            startLessonRequest({
                lessonId,
                classEnrollmentId,
                courseId,
                personId,
                forceSameDomain:
                    cookies[Constants.scormCdnTest.COOKIE_NAME] && cookies[Constants.scormCdnTest.COOKIE_NAME] === Constants.scormCdnTest.FAILED,
            } as LessonStartAndFinishData),
        );
    };

    const description: string = getDescription(content.linkMetadata as LinkMetadata, currentContentTranslation as AvailableTranslation);

    return (
        <div>
            <a className="external-player-link" href="#" onClick={startScormView} rel="noopener noreferrer" target="_blank">
                <div className="box-link">
                    <div className="box-link__cover">
                        {content.mainImage && <img alt="" className="box-link__cover-thumb" src={content.mainImage} />}
                        <div className="box-link__cover-overlay"></div>
                        <div className="box-link__cover-icon">
                            <span className="material-icons-outlined">{Constants.icons.SCHOOL}</span>
                        </div>
                    </div>
                </div>
                {(!description || description.length === 0) && (
                    <div className="content-resume">
                        <p>{strings.EMPTY_LESSON_COMMENT}</p>
                    </div>
                )}
            </a>
            {playScorm && <ScormPlayer onFinish={onFinish} />}
        </div>
    );
};

export default ScormLink;
